export const STEPPER_SETUP_COMPLETE_TEST_CALL_VIDEO_URL =
	'https://storage.googleapis.com/newo-static-files/video/phone-call-simulation.mp4';

export const STEPPER_SETUP_COMPLETE_CALL_STARTED_IMAGE_URL =
	'https://storage.googleapis.com/newo-static-files/static-images/ionos-call-started.png';

export const STEPPER_SETUP_COMPLETE_MODAL_RADIUS = 12;
export const STEPPER_SETUP_COMPLETE_MODAL_SIZE = 606;

export const STEPPER_SETUP_COMPLETE_CHECKLIST_KEYS = [
	'askProducts',
	'requestAppointment',
	'transferManager'
] as const;
